(function () {
  this.LoggerService = function (plugin) {
    this.plugin = plugin;
  };

  this.LoggerService.prototype.Debug = function () {
    if (this.plugin.Config.debug) {
      for (var index = 0; index < arguments.length; index++) {
        console.log('Worst Cycling Lane | ', arguments[index]);
      }
    }
  };

  this.LoggerService.prototype.Log = function () {
    for (var index = 0; index < arguments.length; index++) {
      console.log('Worst Cycling Lane | ', arguments[index]);
    }
  };
}).bind(window.WorstCyclingLane)();
